<template>
  <div class="bottom">
    <p>广州树云科技有限公司</p>
    <p>提供技术支持</p>
  </div>
</template>

<script>
export default {
  name: 'bottom',
  data() {
    return {
    }
  },
  methods: {
    toUser() {
      this.$router.push({ path: '/user' })
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom{
  width: 100%;
  line-height: 15px;
  color: #aaaaaa;
  font-size: 10px;
  font-weight: 400;
  text-align: center;
  position: fixed;
  bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue